// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/antd/dist/reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --theme-primary: #0088FF;
  --theme-secondary: #0059B1;
}
@media (prefers-color-scheme: dark) {
  :root {
    --theme-bg: #2c3036;
    --theme-button-bg: #2c3036;
    --theme-button-bg-hover: #1c1f23;
    --theme-input-bg: #2C2F36;
    --theme-border-color: #3A3D44;
    --theme-text-color: #EDEDED;
  }
}
@media (prefers-color-scheme: light) {
  :root {
    --theme-bg: #FFFFFF;
    --theme-button-bg: #f7f9fc;
    --theme-button-bg-hover: #e2e6eb;
    --theme-input-bg: #FFFFFF;
    --theme-border-color: #E0E0E0;
    --theme-text-color: #212121;
  }
}
html {
  position: relative;
  overflow: hidden;
}
body {
  background-color: var(--theme-bg);
  overflow: hidden;
  /* \`manipulation\` is \`auto\` minus double-tap-to-zoom — the one page-zoom route
       left open by the viewport meta (public/index.html) and helpers/pageZoom.js.
       Panning and pinch still reach the map: touch-action is intersected down the
       tree, and MapLibre's own \`touch-action: none\` on its canvas still wins there. */
  touch-action: manipulation;
}
.main-content {
  background-color: inherit;
  min-height: calc(100vh - 300px);
  border-radius: 6px;
}
.required::before {
  display: inline-block;
  margin-inline-end: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}
#webpack-dev-server-client-overlay {
  display: none !important;
}
/*FIXME */
.hkust.map {
  position: absolute;
  width: 100%;
  inset: 0;
  background: none;
  isolation: isolate;
}
.hkust.map .loading-overlay {
  position: absolute;
  z-index: 1;
  background-color: #090a0a20;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  color: var(--theme-primary);
  inset: 0;
}
.hkust.layout {
  display: flex;
  flex-flow: row nowrap;
  /*.content {
            height: 100%;
            display: flex;
            flex-flow: column;

            .content-head {}

            .content-body {
                flex: 1;
                height: fit-content;
                overflow-y: auto;
                isolation: isolate;
                position: relative;

                margin-block-start: auto;

                .content-inner {
                    padding: 1rem 1rem;
                }

                .content-body-prompt {
                    position: sticky;
                    top: 0;
                    z-index: 9;
                    padding: 12px 24px .5rem;
                    margin-block-end: -1rem;
                }

                .details {
                    padding-block: .75rem 1rem;
                    padding-inline: 1rem;
                    display: grid;
                    gap: .5rem;
                }

                .ant-drawer {
                    .ant-drawer-content-wrapper {
                        max-height: 100%;
                        min-height: 30px;

                        .ant-drawer-content {
                            pointer-events: all;

                            .ant-drawer-body {
                                padding-inline: 16px;
                            }
                        }
                    }
                }
            }
        }*/
}
.hkust.layout .logo {
  height: 62px;
  margin-block: 24px 18px;
  margin-inline: 24px;
  align-self: center;
}
.hkust.layout .content-pane {
  position: absolute;
  inset: 0;
  z-index: 99;
  pointer-events: none;
  display: flex;
  flex-flow: column;
  padding: 16px;
}
.hkust.layout .content-pane .content-drawer-container {
  flex: 1;
  position: relative;
}
.hkust.layout .viewport {
  position: relative;
  height: 100dvh;
  width: 100dvh;
  background: #f3f4ee;
  isolation: isolate;
}
.hkust.layout .viewport .point-of-interests {
  position: absolute;
  /* Just under the 40px search field (16px page padding + 40px). */
  top: 56px;
  left: 18px;
  right: 18px;
  z-index: 99;
  overflow: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-block: calc(16px / 2);
}
.hkust.layout .viewport .point-of-interests::-webkit-scrollbar {
  width: 0;
}
.hkust.layout .viewport .point-of-interests .ant-space {
  flex-wrap: nowrap !important;
}
.hkust.layout .viewport .poi-nav-button {
  transition: all 0.2s ease;
}
.hkust.layout .viewport .poi-nav-button:hover {
  background-color: var(--theme-button-bg-hover) !important;
  transform: translateY(-50%) scale(1.1);
}
.hkust.layout .viewport .poi-nav-button:active {
  transform: translateY(-50%) scale(0.95);
}
.hkust.layout .viewport .maplibregl-popup-content {
  box-shadow: 0 0 24px -12px #000000AA;
  border-radius: 8px;
  padding: 8px 0;
}
.hkust.layout .viewport .map-control {
  pointer-events: none;
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  /* Same side gutter as the search field above. */
  padding: 16px 16px var(--control-bottom-position, 48px);
  z-index: 9;
  bottom: 100px;
  transition: all 0.3s;
  /* Same size as the map buttons beside it (\`controlSize\` in MapLayout). */
}
.hkust.layout .viewport .map-control .floors {
  margin-inline-end: auto;
}
.hkust.layout .viewport .map-control .ant-space {
  pointer-events: all;
}
.hkust.layout .viewport .map-control .ant-btn {
  background-color: var(--theme-button-bg);
  border-color: var(--theme-border-color);
}
.hkust.layout .viewport .map-control .ant-btn:hover {
  background-color: var(--theme-button-bg-hover);
}
.hkust.layout .viewport .map-control .ant-btn.ant-btn-primary {
  background-color: var(--theme-primary);
  border-color: var(--theme-primary);
}
.hkust.layout .viewport .map-control .ant-btn.ant-btn-primary:hover {
  background-color: var(--theme-secondary);
  border-color: var(--theme-secondary);
}
.hkust.layout .viewport .map-control .ant-float-btn {
  width: 40px;
  height: 40px;
}
.hkust.layout .viewport .map-control .ant-float-btn-group {
  pointer-events: all;
  position: absolute;
}
.hkust.layout .viewport .map-control .ant-float-btn-group:has(.ant-float-btn-group-wrap) .ant-float-btn-group-trigger .ant-float-btn-body {
  background: var(--theme-primary);
}
.hkust.layout .viewport .map-control .ant-float-btn-group:has(.ant-float-btn-group-wrap) .ant-float-btn-group-trigger .ant-float-btn-body .ant-typography {
  color: #EDEDED;
}
.hkust.layout .viewport .map-control .ant-float-btn-group .ant-float-btn-group-wrap {
  /* The 40px trigger plus an 8px gap. */
  bottom: 48px;
  /* Whatever is left between the list's bottom and the search field and
                           category chips (which end ~104px down), so a low drawer shows more floors. */
  max-height: calc(100dvh - var(--control-bottom-position, 48px) - 48px - 112px);
  height: auto;
  overflow-y: auto;
  justify-content: start;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.hkust.layout .viewport .map-control .ant-float-btn-group .ant-float-btn-group-wrap::-webkit-scrollbar {
  width: 0;
}
.hkust.layout .viewport .map-control .ant-float-btn-group .ant-float-btn-group-wrap::after {
  content: none;
}
.hkust.layout .viewport .map-control .ant-float-btn-group .ant-float-btn-group-wrap .ant-float-btn {
  flex: 0 0 40px;
}
.hkust.layout .viewport .map-control .ant-segmented {
  pointer-events: all;
  margin-inline-start: auto;
  font-size: 1rem;
  font-weight: 500;
  padding: 5px;
  box-shadow: 0 0 24px -12px #000000AA;
  overflow-y: auto;
  min-width: 58px;
}
.hkust.layout .viewport .map-control .ant-segmented .ant-segmented-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;
  width: 58px;
}
.hkust.layout .viewport .map-control .ant-segmented .ant-segmented-item-selected .ant-segmented-item-label {
  color: #FFFFFF;
}
.hkust.layout .viewport .map-control .ant-segmented .ant-segmented-item .ant-segmented-item-label {
  height: fit-content;
  padding: 0 8px;
}
.hkust.layout .content-body .details .content-inner {
  height: inherit;
  display: flex;
  flex-flow: column;
  gap: 10px;
  padding-block: 10px;
}
.hkust.layout .content-body .details .content-inner .carousel {
  order: 0;
}
.hkust.layout .content-body .details .content-inner .body {
  order: 1;
}
.hkust.layout .content-body .details .content-inner .report {
  order: 2;
  margin-block-start: 10px;
}
.hkust .ant-radio-wrapper .ant-radio-label {
  color: var(--theme-text-color);
}
.hkust a.ant-typography {
  color: var(--theme-primary) !important;
}
.hkust a.ant-typography:hover {
  color: var(--theme-secondary) !important;
}
.hkust .ant-typography {
  color: var(--theme-text-color);
}
.hkust .ant-typography.direction-details {
  color: var(--theme-primary);
}
.hkust .ant-typography.direction-details span {
  color: var(--theme-text-color);
}
.hkust .ant-input-affix-wrapper {
  background-color: var(--theme-bg);
  border-color: var(--theme-border-color);
  color: var(--theme-text-color);
}
.hkust .ant-input-affix-wrapper:focus-within {
  border-color: var(--theme-primary);
}
.hkust .ant-input-affix-wrapper input {
  font-weight: 500;
}
.hkust .ant-input-affix-wrapper input::placeholder {
  color: var(--theme-text-color);
  opacity: 0.35;
}
.hkust .ant-skeleton .ant-skeleton-content .ant-skeleton-paragraph {
  margin: 0;
}
/*ANCHOR overrides*/
.custom-header {
  border-bottom-style: none !important;
}
.custom-header.ant-drawer-header {
  padding-block: 16px calc(16px / 2);
  padding-inline: 16px;
}
.custom-header .ant-drawer-header-title {
  flex-flow: row-reverse;
  align-items: flex-start;
  padding-block-start: 3em;
}
.custom-header .ant-drawer-header-title .ant-drawer-close {
  position: absolute;
  top: 20px;
  right: 12px;
  margin: 0;
  z-index: 9;
}
.custom-header .ant-drawer-header-title .ant-drawer-close .ant-btn-icon svg {
  font-size: 20px;
}
.custom-header .ant-drawer-header-title .handlebar {
  display: block;
  background: var(--theme-bg);
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 56;
  padding: 0;
}
.custom-header .ant-drawer-header-title .handlebar::before {
  content: '';
  position: absolute;
  width: 15%;
  height: 6px;
  border-radius: 3px;
  background: var(--theme-primary);
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.custom-header .ant-drawer-header-title .handlebar .ant-flex {
  top: 20px;
  left: 12px;
  position: absolute;
}
.custom-header .ant-drawer-header-title .handlebar .ant-flex .ant-btn {
  height: fit-content;
  width: fit-content;
  padding: 2px 4px;
}
.custom-header .ant-drawer-header-title .handlebar .ant-flex .ant-btn .ant-btn-icon svg {
  font-size: 18px;
}
.ant-space .ant-space-item .ant-checkbox-group.destination-accessibility {
  display: flex;
  flex-flow: column nowrap;
  gap: 8px;
}
.ant-space .ant-space-item .ant-checkbox-group.destination-accessibility .ant-checkbox-wrapper {
  width: 100%;
}
.ant-divider {
  border-color: var(--theme-border-color);
}
.ant-list {
  border-color: var(--theme-border-color);
}
.ant-list .list-item-skeleton {
  padding: 12px 18px;
}
.ant-list .ant-list-items .ant-list-item {
  cursor: pointer;
  border-block-end-color: var(--theme-border-color);
  padding: 12px 18px;
}
.ant-list .ant-list-items .ant-list-item.active .ant-typography:not(span) {
  color: var(--theme-primary);
}
.ant-list .ant-list-items .ant-list-item:not(.info):hover .ant-typography:not(span) {
  color: var(--theme-secondary);
}
.ant-drawer {
  position: absolute !important;
  height: 100%;
  top: unset;
  bottom: 0;
  margin-inline: calc(16px * -1);
  margin-block-end: calc(16px * -1);
}
.ant-drawer .ant-drawer-content-wrapper {
  background: transparent;
  border-radius: 1em 1em 0 0 !important;
  overflow: hidden;
}
.ant-drawer .ant-drawer-content-wrapper .ant-drawer-content {
  overflow-y: hidden;
  background: var(--theme-bg);
}
.ant-drawer .ant-drawer-content-wrapper .ant-drawer-content .ant-drawer-body {
  padding: 16px;
  padding-block-start: 0;
}
.ant-drawer .ant-drawer-content-wrapper .ant-drawer-content .ant-drawer-body .details {
  padding-inline: 0;
  padding-block: 0;
}
.hkust.transparent,
.hkust .transparent {
  background: transparent;
}
.hkust.opaque,
.hkust .opaque {
  background: var(--theme-bg);
}
.hkust.rounded,
.hkust .rounded {
  border-radius: 2em;
  box-shadow: 0px 0px 8px -4px rgba(0, 0, 0, 0.408);
}
.hkust.rounded-top,
.hkust .rounded-top {
  border-radius: 2em 2em 0 0;
  box-shadow: 0px 0px 12px -6px rgba(0, 0, 0, 0.408);
}
.hkust .location-seach .ant-input-affix-wrapper {
  border-radius: 2em;
}
.hkust .location-search-select {
  width: 100%;
}
.hkust .location-search-select.ant-select-single.ant-select-lg {
  height: 40px;
}
.hkust .location-search-select .ant-select-selector {
  background: var(--theme-bg);
  border-style: none;
  box-shadow: 0px 0px 12px -6px rgba(0, 0, 0, 0.408);
}
.hkust .location-search-select .ant-select .ant-select-arrow {
  inset-inline-end: 16px !important;
}
.hkust .location-search-select .ant-select-selector {
  border-radius: 2em;
  padding-inline: 16px !important;
}
.hkust .hkust.location-seach {
  pointer-events: all;
}
.hkust .direction-search {
  pointer-events: all;
}
.hkust .floor-selector {
  inset: unset;
  transform: unset;
  bottom: var(--control-bottom-position, 48px);
  left: 16px;
  transition: bottom 0.3s;
}
.hkust .floor-selector .ant-float-btn {
  width: 40px;
  height: 40px;
  justify-items: center;
  margin: 0;
  background: var(--theme-button-bg);
}
.hkust .floor-selector .ant-float-btn .ant-float-btn-body {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: inherit;
}
.hkust .floor-selector .ant-float-btn .ant-float-btn-body:hover {
  background-color: var(--theme-button-bg-hover);
}
.hkust .floor-selector .ant-float-btn.ant-float-btn-group-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
}
.hkust .floor-selector .ant-float-btn.ant-float-btn-group-trigger .ant-float-btn-body {
  width: 40px;
  height: 40px;
  /*background: @theme-primary;*/
}
.hkust .floor-selector .ant-float-btn.ant-float-btn-group-trigger .ant-float-btn-body .ant-typography {
  /*color: #FFFFFF;*/
}
.hkust .floor-selector .ant-float-btn.active .ant-float-btn-body {
  background: var(--theme-primary);
}
.hkust .floor-selector .ant-float-btn.active .ant-float-btn-body .ant-typography {
  color: #FFFFFF;
}
.hkust .floor-selector .ant-float-btn .ant-float-btn-body > .ant-float-btn-content,
.hkust .floor-selector .ant-float-btn .ant-float-btn-body > .ant-float-btn-content > .ant-float-btn-icon {
  padding: 0;
  width: 100%;
  font-weight: 500;
}
@media (prefers-color-scheme: dark) {
  .hkust.layout .logo {
    filter: grayscale(1) brightness(100);
  }
}
@media screen and (width > 800px) {
  .hkust.layout {
    height: 100dvh;
    width: 100dvw;
  }
  .hkust.layout .content-pane {
    width: 408px;
    position: relative;
    display: flex;
    flex-flow: column;
    pointer-events: all;
    padding: unset;
    height: 100%;
  }
  .hkust.layout .content-pane .location-seach {
    padding: 16px 22px;
  }
  .hkust.layout .content-pane .location-search-select {
    width: 100%;
  }
  .hkust.layout .content-pane .location-search-select.ant-select-single.ant-select-lg {
    height: 48px;
  }
  .hkust.layout .content-pane .location-search-select .ant-select-selector {
    background: var(--theme-bg);
    border-style: solid;
    box-shadow: none;
  }
  .hkust.layout .content-pane .location-search-select .ant-select .ant-select-arrow {
    inset-inline-end: 16px !important;
  }
  .hkust.layout .content-pane .location-search-select .ant-select-selector {
    border-radius: 0.5em;
    padding-inline: 16px !important;
  }
  .hkust.layout .content-pane .direction-search {
    margin-block-end: 16px;
  }
  .hkust.layout .content-pane .content-drawer-container {
    position: relative;
    flex: 0 1 100%;
    height: 100%;
    overflow-y: scroll;
  }
  .hkust.layout .content-pane .content-drawer-container::-webkit-scrollbar {
    display: none;
  }
  .hkust.layout .content-pane .content-prompt {
    position: sticky;
    top: 0;
    padding-inline: 22px;
    z-index: 99;
  }
  .hkust.layout .content-pane .content {
    padding-inline: 22px;
    position: relative;
    isolation: isolate;
    width: 100%;
  }
  .hkust.layout .content-pane .content-body {
    isolation: isolate;
    height: inherit;
    min-height: 580px;
    /*padding-block-start: @space-block;*/
    /*flex: 1;
                        margin-block-start: unset;
                        display: flex;
                        flex-flow: column;
    
                        .infinite-scroll-component {
                            padding: .75rem 1rem;
                        }
    
                        .path-options {
                            padding: 24px;
                            margin-block-start: auto;
                        }*/
  }
  .hkust.layout .content-pane .content-body .details {
    height: 100%;
  }
  .hkust.layout .content-pane .content-body .details .cover {
    margin-inline: calc(22px * -1);
  }
  .hkust.layout .content-pane .content-body .details .content-inner .carousel,
  .hkust.layout .content-pane .content-body .details .content-inner .body,
  .hkust.layout .content-pane .content-body .details .content-inner .report {
    order: unset;
  }
  .hkust.layout .viewport {
    position: relative;
    width: auto;
    flex: 1;
  }
  .hkust.layout .viewport .point-of-interests {
    top: 24px;
    overflow-x: unset;
    padding-block: unset;
  }
  .hkust.layout .viewport .point-of-interests .ant-space {
    flex-wrap: wrap !important;
  }
  .hkust.layout .viewport .poi-nav-button {
    display: none !important;
  }
  .hkust.layout .viewport .map-control {
    width: 100%;
    padding: 24px;
  }
  .hkust.layout .viewport .map-control .ant-float-btn {
    width: 58px;
    height: 58px;
  }
  .hkust.layout .viewport .map-control .ant-float-btn-group .ant-float-btn-group-wrap {
    bottom: 76px;
    max-height: 364px;
  }
  .hkust.layout .viewport .map-control .ant-float-btn-group .ant-float-btn-group-wrap .ant-float-btn {
    flex: 0 0 58px;
  }
  .hkust .location-seach .ant-input-affix-wrapper {
    border-radius: 0.5em;
  }
  .hkust .floor-selector {
    bottom: 24px;
    left: 24px;
  }
  .hkust .floor-selector .ant-float-btn .ant-float-btn-body,
  .hkust .floor-selector .ant-float-btn.ant-float-btn-group-trigger .ant-float-btn-body {
    width: 48px;
    height: 48px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.less"],"names":[],"mappings":"AAEA;EAmBI,wBAAA;EACA,0BAAA;AAlBJ;AADI;EAAA;IACI,mBAAA;IACA,0BAAA;IACA,gCAAA;IACA,yBAAA;IACA,6BAAA;IACA,2BAAA;EAIN;AACF;AAFI;EAAA;IACI,mBAAA;IACA,0BAAA;IACA,gCAAA;IACA,yBAAA;IACA,6BAAA;IACA,2BAAA;EAKN;AACF;AAgBA;EACI,kBAAA;EACA,gBAAA;AAdJ;AAiBA;EACI,iCAAA;EACA,gBAAA;EAfF;;;sFAGoF;EAiBlF,0BAAA;AAfJ;AAkBA;EACI,yBAAA;EACA,+BAAA;EACA,kBAAA;AAhBJ;AAmBA;EACI,qBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,YAAA;AAjBJ;AAoBA;EACI,wBAAA;AAlBJ;AACA,SAAS;AAsBL;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AApBR;AAeI;EAQQ,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,QAAA;AApBZ;AAwBI;EACI,aAAA;EACA,qBAAA;EAtBN;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;UAkDQ;AACV;AA/BI;EAKQ,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AA6BZ;AArCI;EAYQ,kBAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;AA4BZ;AA9CI;EAqBY,OAAA;EACA,kBAAA;AA4BhB;AAlDI;EA2BQ,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AA0BZ;AAzDI;EAkCY,kBAAA;EA0Bd,iEAAiE;EAxBnD,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,6BAAA;AA0BhB;AAxBgB;EACI,QAAA;AA0BpB;AAxEI;EAkDgB,4BAAA;AAyBpB;AA3EI;EAuDY,yBAAA;AAuBhB;AArBgB;EACI,yDAAA;EACA,sCAAA;AAuBpB;AApBgB;EACI,uCAAA;AAsBpB;AAhBgB;EACI,oCAAA;EACA,kBAAA;EACA,cAAA;AAkBpB;AA1FI;EAgFY,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EAad,gDAAgD;EAXlC,uDAAA;EACA,UAAA;EACA,aAAA;EACA,oBAAA;EAad,yEAAyE;AAC3E;AAvGI;EA4FgB,uBAAA;AAcpB;AA1GI;EAgGgB,mBAAA;AAapB;AA7GI;EAoGgB,wCAAA;EACA,uCAAA;AAYpB;AAVoB;EACI,8CAAA;AAYxB;AANoB;EACI,sCAAA;EACA,kCAAA;AAQxB;AANwB;EACI,wCAAA;EACA,oCAAA;AAQ5B;AA5HI;EA2HgB,WAAA;EACA,YAAA;AAIpB;AAhII;EAgIgB,mBAAA;EACA,kBAAA;AAGpB;AADoB;EAGY,gCAAA;AAChC;AAJoB;EAMgB,cAAA;AACpC;AA1II;EA4IF,sCAAsC;EAKhB,YAAA;EAHtB;uGACqG;EAK/E,8EAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;AAHxB;AAKwB;EACI,QAAA;AAH5B;AAMwB;EACI,aAAA;AAJ5B;AA5JI;EAoKwB,cAAA;AAL5B;AA/JI;EA0KgB,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AARpB;AAzKI;EAqLoB,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AATxB;AAWwB;EAEQ,cAAA;AAVhC;AAnLI;EAkMwB,mBAAA;EACA,cAAA;AAZ5B;AAoBY;EAIY,eAAA;EACA,aAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AArBxB;AAaY;EAWgB,QAAA;AArB5B;AAUY;EAegB,QAAA;AAtB5B;AAOY;EAmBgB,QAAA;EACA,wBAAA;AAvB5B;AA7NA;EAkTY,8BAAA;AAlFZ;AAuFQ;EACI,sCAAA;AArFZ;AAuFY;EACI,wCAAA;AArFhB;AAtOA;EAiUQ,8BAAA;AAxFR;AA0FQ;EACI,2BAAA;AAxFZ;AAuFQ;EAIQ,8BAAA;AAxFhB;AA/OA;EA6UQ,iCAAA;EACA,uCAAA;EACA,8BAAA;AA3FR;AA6FQ;EACI,kCAAA;AA3FZ;AAvPA;EAsVY,gBAAA;AA5FZ;AA8FY;EACI,8BAAA;EACA,aAAA;AA5FhB;AA9PA;EAkWgB,SAAA;AAjGhB;AACA,mBAAmB;AAuGnB;EACI,oCAAA;AArGJ;AAuGI;EACI,kCAAA;EACA,oBAAA;AArGR;AAgGA;EASQ,sBAAA;EACA,uBAAA;EACA,wBAAA;AAtGR;AA2FA;EAcY,kBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAtGZ;AAoFA;EAsBoB,eAAA;AAvGpB;AAiFA;EA6BY,cAAA;EACA,2BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,UAAA;AA3GZ;AA6GY;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AA3GhB;AA4DA;EAmDgB,SAAA;EACA,UAAA;EACA,kBAAA;AA5GhB;AAuDA;EAwDoB,mBAAA;EACA,kBAAA;EACA,gBAAA;AA5GpB;AAkDA;EA8D4B,eAAA;AA7G5B;AA0HY;EACI,aAAA;EACA,wBAAA;EACA,QAAA;AAxHhB;AAqHY;EAMQ,WAAA;AAxHpB;AA+HA;EACI,uCAAA;AA7HJ;AAgIA;EACI,uCAAA;AA9HJ;AA6HA;EAIQ,kBAAA;AA9HR;AA0HA;EASY,eAAA;EACA,iDAAA;EACA,kBAAA;AAhIZ;AAkIY;EAEQ,2BAAA;AAjIpB;AAsIgB;EAEQ,6BAAA;AArIxB;AA6IA;EACI,6BAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;EACA,iCAAA;AA3IJ;AAqIA;EASQ,uBAAA;EACA,qCAAA;EACA,gBAAA;AA3IR;AAgIA;EAcY,kBAAA;EACA,2BAAA;AA3IZ;AA4HA;EAkBgB,aAAA;EACA,sBAAA;AA3IhB;AAwHA;EAsBoB,iBAAA;EACA,gBAAA;AA3IpB;AAoJI;;EAEI,uBAAA;AAlJR;AAqJI;;EAEI,2BAAA;AAnJR;AAsJI;;EAEI,kBAAA;EACA,iDAAA;AApJR;AAuJI;;EAEI,0BAAA;EACA,kDAAA;AArJR;AAgIA;EA0BY,kBAAA;AAvJZ;AA6HA;EA+BQ,WAAA;AAzJR;AA2JQ;EACI,YAAA;AAzJZ;AAuHA;EAsCY,2BAAA;EACA,kBAAA;EACA,kDAAA;AA1JZ;AAkHA;EA8CgB,iCAAA;AA7JhB;AA+GA;EAmDY,kBAAA;EACA,+BAAA;AA/JZ;AA2GA;EA0DQ,mBAAA;AAlKR;AAwGA;EA8DQ,mBAAA;AAnKR;AAqGA;EAmEQ,YAAA;EACA,gBAAA;EACA,4CAAA;EACA,UAAA;EACA,uBAAA;AArKR;AA8FA;EA0EY,WAAA;EACA,YAAA;EACA,qBAAA;EACA,SAAA;EACA,kCAAA;AArKZ;AAuFA;EAiFgB,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,mBAAA;AAtKhB;AAwKgB;EACI,8CAAA;AAtKpB;AA0KY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAxKhB;AAqKY;EAMQ,WAAA;EACA,YAAA;EAxKlB,8BAA8B;AAChC;AAgKY;EA9JV,kBAAkB;AACpB;AA6KY;EAEQ,gCAAA;AA5KpB;AA0KY;EAKY,cAAA;AA5KxB;AA2DA;;EAwHgB,UAAA;EACA,WAAA;EACA,gBAAA;AA/KhB;AAqLA;EAEQ;IAEQ,oCAAA;EArLd;AACF;AA2LA;EAMQ;IACI,cAAA;IACA,aAAA;EA9LV;EA4LM;IAKQ,YAAA;IACA,kBAAA;IACA,aAAA;IACA,iBAAA;IACA,mBAAA;IACA,cAAA;IACA,YAAA;EA9Ld;EAmLM;IAcY,kBAAA;EA9LlB;EAgLM;IAkBY,WAAA;EA/LlB;EAiMkB;IACI,YAAA;EA/LtB;EA0KM;IAyBgB,2BAAA;IACA,mBAAA;IACA,gBAAA;EAhMtB;EAqKM;IAiCoB,iCAAA;EAnM1B;EAkKM;IAsCgB,oBAAA;IACA,+BAAA;EArMtB;EA8JM;IA6CY,sBAAA;EAxMlB;EA2JM;IAiDY,kBAAA;IACA,cAAA;IACA,YAAA;IACA,kBAAA;EAzMlB;EA2MkB;IACI,aAAA;EAzMtB;EAkJM;IA4DY,gBAAA;IACA,MAAA;IACA,oBAAA;IACA,WAAA;EA3MlB;EA4IM;IAoEY,oBAAA;IACA,kBAAA;IACA,kBAAA;IACA,WAAA;EA7MlB;EAiNkB;IACI,kBAAA;IACA,eAAA;IACA,iBAAA;IA/MpB,qCAAqC;IACrC;;;;;;;;;;;;0BAYsB;EACxB;EA8LkB;IAqBQ,YAAA;EAhN1B;EA2LkB;IAwBY,8BAAA;EAhN9B;EAwLkB;;;IAgCgB,YAAA;EAnNlC;EAwGM;IAqHQ,kBAAA;IACA,WAAA;IACA,OAAA;EA1Nd;EAmGM;IA0HY,SAAA;IACA,iBAAA;IACA,oBAAA;EA1NlB;EA8FM;IA+HgB,0BAAA;EA1NtB;EA2FM;IAoIY,wBAAA;EA5NlB;EAwFM;IAwIY,WAAA;IACA,aAAA;EA7NlB;EAoFM;IA4IgB,WAAA;IACA,YAAA;EA7NtB;EAgFM;IAkJoB,YAAA;IACA,iBAAA;EA/N1B;EA4EM;IAsJwB,cAAA;EA/N9B;EAwEE;IAiKY,oBAAA;EAtOd;EAqEE;IAsKQ,YAAA;IACA,UAAA;EAxOV;EAiEE;;IA2KY,WAAA;IACA,YAAA;EAxOd;AACF","sourcesContent":["@import '~antd/dist/reset.css';\n\n:root {\n    @media (prefers-color-scheme: dark) {\n        --theme-bg: #2c3036;\n        --theme-button-bg: #2c3036;\n        --theme-button-bg-hover: #1c1f23;\n        --theme-input-bg: #2C2F36;\n        --theme-border-color: #3A3D44;\n        --theme-text-color: #EDEDED;\n    }\n\n    @media (prefers-color-scheme: light) {\n        --theme-bg: #FFFFFF;\n        --theme-button-bg: #f7f9fc;\n        --theme-button-bg-hover: #e2e6eb;\n        --theme-input-bg: #FFFFFF;\n        --theme-border-color: #E0E0E0;\n        --theme-text-color: #212121\n    }\n\n    --theme-primary: #0088FF;\n    --theme-secondary: #0059B1;\n}\n\n\n@gray-color: #f5f5f5;\n@theme-bg: var(--theme-bg);\n@theme-button-bg: var(--theme-button-bg);\n@theme-button-bg-hover: var(--theme-button-bg-hover);\n\n@theme-text-color: var(--theme-text-color);\n@theme-border-color: var(--theme-border-color);\n@theme-primary: var(--theme-primary);\n@theme-secondary: var(--theme-secondary);\n\n@space: 16px;\n@space-inline: 16px;\n@space-block: 10px;\n\nhtml {\n    position: relative;\n    overflow: hidden;\n}\n\nbody {\n    background-color: @theme-bg;\n    overflow: hidden;\n    /* `manipulation` is `auto` minus double-tap-to-zoom — the one page-zoom route\n       left open by the viewport meta (public/index.html) and helpers/pageZoom.js.\n       Panning and pinch still reach the map: touch-action is intersected down the\n       tree, and MapLibre's own `touch-action: none` on its canvas still wins there. */\n    touch-action: manipulation;\n}\n\n.main-content {\n    background-color: inherit;\n    min-height: calc(100vh - 300px);\n    border-radius: 6px;\n}\n\n.required::before {\n    display: inline-block;\n    margin-inline-end: 4px;\n    color: #ff4d4f;\n    font-size: 14px;\n    font-family: SimSun, sans-serif;\n    line-height: 1;\n    content: \"*\";\n}\n\n#webpack-dev-server-client-overlay {\n    display: none !important;\n}\n\n/*FIXME */\n.hkust {\n    &.map {\n        position: absolute;\n        width: 100%;\n        inset: 0;\n        background: none;\n        isolation: isolate;\n\n        .loading-overlay {\n            position: absolute;\n            z-index: 1;\n            background-color: #090a0a20;\n            display: flex;\n            flex-flow: column;\n            align-items: center;\n            justify-content: center;\n            color: @theme-primary;\n            inset: 0;\n        }\n    }\n\n    &.layout {\n        display: flex;\n        flex-flow: row nowrap;\n\n        .logo {\n            height: 62px;\n            margin-block: 24px 18px;\n            margin-inline: 24px;\n            align-self: center;\n        }\n\n        .content-pane {\n            position: absolute;\n            inset: 0;\n            z-index: 99;\n            pointer-events: none;\n            display: flex;\n            flex-flow: column;\n            padding: @space;\n\n            .content-drawer-container {\n                flex: 1;\n                position: relative;\n            }\n        }\n\n        .viewport {\n            position: relative;\n            height: 100dvh;\n            width: 100dvh;\n            background: #f3f4ee;\n            isolation: isolate;\n\n            .point-of-interests {\n                position: absolute;\n                /* Just under the 40px search field (16px page padding + 40px). */\n                top: 56px;\n                left: 18px;\n                right: 18px;\n                z-index: 99;\n                overflow: hidden;\n                scrollbar-width: none;\n                -ms-overflow-style: none;\n                padding-block: calc(@space / 2);\n\n                &::-webkit-scrollbar {\n                    width: 0;\n                }\n\n                .ant-space {\n                    flex-wrap: nowrap !important;\n                }\n            }\n\n            .poi-nav-button {\n                transition: all 0.2s ease;\n\n                &:hover {\n                    background-color: var(--theme-button-bg-hover) !important;\n                    transform: translateY(-50%) scale(1.1);\n                }\n\n                &:active {\n                    transform: translateY(-50%) scale(0.95);\n                }\n            }\n\n            .maplibregl-popup {\n\n                &-content {\n                    box-shadow: 0 0 24px -12px #000000AA;\n                    border-radius: 8px;\n                    padding: 8px 0;\n                }\n\n                .popup-container {}\n            }\n\n\n            .map-control {\n                pointer-events: none;\n                position: absolute;\n                inset: 0;\n                height: 100%;\n                width: 100%;\n                /* Same side gutter as the search field above. */\n                padding: @space @space var(--control-bottom-position, 48px);\n                z-index: 9;\n                bottom: 100px;\n                transition: all .3s;\n\n                .floors {\n                    margin-inline-end: auto;\n                }\n\n                .ant-space {\n                    pointer-events: all;\n                }\n\n                .ant-btn {\n                    background-color: @theme-button-bg;\n                    border-color: @theme-border-color;\n\n                    &:hover {\n                        background-color: @theme-button-bg-hover;\n                    }\n\n                    // The 360 toggle shows itself as on with `type=\"primary\"` and a white icon.\n                    // The neutral background above applies to every button in this column and\n                    // would otherwise win, leaving a white icon on a near-white button.\n                    &.ant-btn-primary {\n                        background-color: @theme-primary;\n                        border-color: @theme-primary;\n\n                        &:hover {\n                            background-color: @theme-secondary;\n                            border-color: @theme-secondary;\n                        }\n                    }\n                }\n\n                /* Same size as the map buttons beside it (`controlSize` in MapLayout). */\n                .ant-float-btn {\n                    width: 40px;\n                    height: 40px;\n                }\n\n                .ant-float-btn-group {\n                    pointer-events: all;\n                    position: absolute;\n\n                    &:has(.ant-float-btn-group-wrap) {\n                        .ant-float-btn-group-trigger {\n                            .ant-float-btn-body {\n                                background: @theme-primary;\n\n                                .ant-typography {\n                                    color: #EDEDED\n                                }\n                            }\n                        }\n                    }\n\n                    .ant-float-btn-group-wrap {\n                        /* The 40px trigger plus an 8px gap. */\n                        bottom: 48px;\n                        /* Whatever is left between the list's bottom and the search field and\n                           category chips (which end ~104px down), so a low drawer shows more floors. */\n                        max-height: calc(100dvh - var(--control-bottom-position, 48px) - 48px - 112px);\n                        height: auto;\n                        overflow-y: auto;\n                        justify-content: start;\n                        scrollbar-width: none;\n                        -ms-overflow-style: none;\n\n                        &::-webkit-scrollbar {\n                            width: 0;\n                        }\n\n                        &::after {\n                            content: none;\n                        }\n\n                        .ant-float-btn {\n                            flex: 0 0 40px;\n                        }\n                    }\n                }\n\n                .ant-segmented {\n                    pointer-events: all;\n                    margin-inline-start: auto;\n                    font-size: 1rem;\n                    font-weight: 500;\n                    padding: 5px;\n                    box-shadow: 0 0 24px -12px #000000AA;\n                    overflow-y: auto;\n                    min-width: 58px;\n\n\n                    .ant-segmented-item {\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        height: 58px;\n                        width: 58px;\n\n                        &-selected {\n                            .ant-segmented-item-label {\n                                color: #FFFFFF;\n                            }\n                        }\n\n                        .ant-segmented-item-label {\n                            height: fit-content;\n                            padding: 0 8px;\n                        }\n                    }\n                }\n            }\n        }\n\n        .content {\n            &-body {\n                .details {\n                    .content-inner {\n                        display: flex;\n                        height: inherit;\n                        display: flex;\n                        flex-flow: column;\n                        gap: @space-block;\n                        padding-block: @space-block;\n\n                        .carousel {\n                            order: 0;\n                        }\n\n                        .body {\n                            order: 1;\n                        }\n\n                        .report {\n                            order: 2;\n                            margin-block-start: @space-block;\n                        }\n                    }\n                }\n            }\n        }\n\n        /*.content {\n            height: 100%;\n            display: flex;\n            flex-flow: column;\n\n            .content-head {}\n\n            .content-body {\n                flex: 1;\n                height: fit-content;\n                overflow-y: auto;\n                isolation: isolate;\n                position: relative;\n\n                margin-block-start: auto;\n\n                .content-inner {\n                    padding: 1rem 1rem;\n                }\n\n                .content-body-prompt {\n                    position: sticky;\n                    top: 0;\n                    z-index: 9;\n                    padding: 12px 24px .5rem;\n                    margin-block-end: -1rem;\n                }\n\n                .details {\n                    padding-block: .75rem 1rem;\n                    padding-inline: 1rem;\n                    display: grid;\n                    gap: .5rem;\n                }\n\n                .ant-drawer {\n                    .ant-drawer-content-wrapper {\n                        max-height: 100%;\n                        min-height: 30px;\n\n                        .ant-drawer-content {\n                            pointer-events: all;\n\n                            .ant-drawer-body {\n                                padding-inline: 16px;\n                            }\n                        }\n                    }\n                }\n            }\n        }*/\n    }\n\n    .ant-radio-wrapper {\n        .ant-radio-label {\n            color: @theme-text-color;\n        }\n    }\n\n    a {\n        &.ant-typography {\n            color: @theme-primary  !important;\n\n            &:hover {\n                color: @theme-secondary  !important;\n            }\n        }\n    }\n\n    .ant-typography {\n        color: @theme-text-color;\n\n        &.direction-details {\n            color: @theme-primary;\n\n            span {\n                color: @theme-text-color;\n            }\n        }\n    }\n\n    .ant-input-affix-wrapper {\n        background-color: @theme-bg;\n        border-color: @theme-border-color;\n        color: @theme-text-color;\n\n        &:focus-within {\n            border-color: @theme-primary;\n        }\n\n        input {\n            font-weight: 500;\n\n            &::placeholder {\n                color: @theme-text-color;\n                opacity: .35;\n            }\n        }\n    }\n\n    .ant-skeleton {\n        .ant-skeleton-content {\n            .ant-skeleton-paragraph {\n                margin: 0;\n            }\n        }\n    }\n}\n\n/*ANCHOR overrides*/\n.custom-header {\n    border-bottom-style: none !important;\n\n    &.ant-drawer-header {\n        padding-block: @space calc(@space / 2);\n        padding-inline: @space;\n    }\n\n    .ant-drawer-header-title {\n        flex-flow: row-reverse;\n        align-items: flex-start;\n        padding-block-start: 3em;\n\n        .ant-drawer-close {\n            position: absolute;\n            top: 20px;\n            right: 12px;\n            margin: 0;\n            z-index: 9;\n\n            .ant-btn-icon {\n                svg {\n                    font-size: 20px;\n                }\n            }\n\n        }\n\n        .handlebar {\n            display: block;\n            background: @theme-bg;\n            width: 100%;\n            position: absolute;\n            top: 0;\n            left: 0;\n            height: 56;\n            padding: 0;\n\n            &::before {\n                content: '';\n                position: absolute;\n                width: 15%;\n                height: 6px;\n                border-radius: 3px;\n                background: @theme-primary;\n                top: 10px;\n                left: 50%;\n                transform: translateX(-50%);\n            }\n\n            .ant-flex {\n                top: 20px;\n                left: 12px;\n                position: absolute;\n\n                .ant-btn {\n                    height: fit-content;\n                    width: fit-content;\n                    padding: 2px 4px;\n\n                    .ant-btn-icon {\n                        svg {\n                            font-size: 18px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.ant-space {\n    .ant-space-item {\n        .ant-checkbox-group {\n\n            &.destination-accessibility {\n                display: flex;\n                flex-flow: column nowrap;\n                gap: 8px;\n\n                .ant-checkbox-wrapper {\n                    width: 100%;\n                }\n            }\n        }\n    }\n}\n\n.ant-divider {\n    border-color: @theme-border-color;\n}\n\n.ant-list {\n    border-color: @theme-border-color;\n\n    .list-item-skeleton {\n        padding: 12px 18px;\n    }\n\n    .ant-list-items {\n        .ant-list-item {\n            cursor: pointer;\n            border-block-end-color: @theme-border-color;\n            padding: 12px 18px;\n\n            &.active {\n                .ant-typography:not(span) {\n                    color: @theme-primary\n                }\n            }\n\n            &:not(.info) {\n                &:hover {\n                    .ant-typography:not(span) {\n                        color: @theme-secondary\n                    }\n                }\n            }\n        }\n    }\n}\n\n.ant-drawer {\n    position: absolute !important;\n    height: 100%;\n    top: unset;\n    bottom: 0;\n    margin-inline: calc(@space * -1);\n    margin-block-end: calc(@space * -1);\n\n    .ant-drawer-content-wrapper {\n        background: transparent;\n        border-radius: 1em 1em 0 0 !important;\n        overflow: hidden;\n\n        .ant-drawer-content {\n            overflow-y: hidden;\n            background: @theme-bg;\n\n            .ant-drawer-body {\n                padding: @space;\n                padding-block-start: 0;\n\n                .details {\n                    padding-inline: 0;\n                    padding-block: 0;\n                }\n            }\n        }\n    }\n}\n\n.hkust {\n\n    &.transparent,\n    .transparent {\n        background: transparent\n    }\n\n    &.opaque,\n    .opaque {\n        background: @theme-bg\n    }\n\n    &.rounded,\n    .rounded {\n        border-radius: 2em;\n        box-shadow: 0px 0px 8px -4px rgba(0, 0, 0, 0.408);\n    }\n\n    &.rounded-top,\n    .rounded-top {\n        border-radius: 2em 2em 0 0;\n        box-shadow: 0px 0px 12px -6px rgba(0, 0, 0, 0.408);\n    }\n\n    .location-seach {\n        .ant-input-affix-wrapper {\n            border-radius: 2em;\n        }\n    }\n\n    .location-search-select {\n        width: 100%;\n\n        &.ant-select-single.ant-select-lg {\n            height: 40px;\n        }\n\n        .ant-select-selector {\n            background: @theme-bg;\n            border-style: none;\n            box-shadow: 0px 0px 12px -6px rgba(0, 0, 0, 0.408);\n\n        }\n\n        .ant-select {\n            .ant-select-arrow {\n                inset-inline-end: 16px !important;\n            }\n        }\n\n        .ant-select-selector {\n            border-radius: 2em;\n            padding-inline: 16px !important;\n\n        }\n    }\n\n    .hkust.location-seach {\n        pointer-events: all;\n    }\n\n    .direction-search {\n        pointer-events: all;\n    }\n\n    .floor-selector {\n\n        inset: unset;\n        transform: unset;\n        bottom: var(--control-bottom-position, 48px);\n        left: @space;\n        transition: bottom .3s;\n\n        .ant-float-btn {\n            width: 40px;\n            height: 40px;\n            justify-items: center;\n            margin: 0;\n            background: @theme-button-bg;\n\n            .ant-float-btn-body {\n                width: 40px;\n                height: 40px;\n                border-radius: 4px;\n                background: inherit;\n                background: inherit;\n\n                &:hover {\n                    background-color: @theme-button-bg-hover;\n                }\n            }\n\n            &.ant-float-btn-group-trigger {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n\n                .ant-float-btn-body {\n                    width: 40px;\n                    height: 40px;\n                    /*background: @theme-primary;*/\n\n                    .ant-typography {\n                        /*color: #FFFFFF;*/\n                    }\n                }\n            }\n\n            &.active {\n                .ant-float-btn-body {\n                    background: @theme-primary;\n\n                    .ant-typography {\n                        color: #FFFFFF;\n                    }\n                }\n            }\n\n            .ant-float-btn-body>.ant-float-btn-content,\n            .ant-float-btn-body>.ant-float-btn-content>.ant-float-btn-icon {\n                padding: 0;\n                width: 100%;\n                font-weight: 500;\n            }\n        }\n    }\n}\n\n@media (prefers-color-scheme: dark) {\n    .hkust {\n        &.layout {\n            .logo {\n                filter: grayscale(1) brightness(100);\n                ;\n            }\n        }\n    }\n}\n\n@media screen and (width > 800px) {\n    @space: 18px;\n    @space-inline: 22px;\n    @space-block: 16px;\n\n    .hkust {\n        &.layout {\n            height: 100dvh;\n            width: 100dvw;\n\n            .content-pane {\n                width: 408px;\n                position: relative;\n                display: flex;\n                flex-flow: column;\n                pointer-events: all;\n                padding: unset;\n                height: 100%;\n\n                .location-seach {\n                    padding: @space-block @space-inline;\n                }\n\n                .location-search-select {\n                    width: 100%;\n\n                    &.ant-select-single.ant-select-lg {\n                        height: 48px;\n                    }\n\n                    .ant-select-selector {\n                        background: @theme-bg;\n                        border-style: solid;\n                        box-shadow: none;\n\n                    }\n\n                    .ant-select {\n                        .ant-select-arrow {\n                            inset-inline-end: 16px !important;\n                        }\n                    }\n\n                    .ant-select-selector {\n                        border-radius: .5em;\n                        padding-inline: 16px !important;\n\n                    }\n                }\n\n                .direction-search {\n                    margin-block-end: @space-block;\n                }\n\n                .content-drawer-container {\n                    position: relative;\n                    flex: 0 1 100%;\n                    height: 100%;\n                    overflow-y: scroll;\n\n                    &::-webkit-scrollbar {\n                        display: none;\n                    }\n                }\n\n                .content-prompt {\n                    position: sticky;\n                    top: 0;\n                    padding-inline: @space-inline;\n                    z-index: 99;\n                }\n\n\n                .content {\n                    padding-inline: @space-inline;\n                    position: relative;\n                    isolation: isolate;\n                    width: 100%;\n\n                    &-head {}\n\n                    &-body {\n                        isolation: isolate;\n                        height: inherit;\n                        min-height: 580px;\n                        /*padding-block-start: @space-block;*/\n\n                        /*flex: 1;\n                        margin-block-start: unset;\n                        display: flex;\n                        flex-flow: column;\n    \n                        .infinite-scroll-component {\n                            padding: .75rem 1rem;\n                        }\n    \n                        .path-options {\n                            padding: 24px;\n                            margin-block-start: auto;\n                        }*/\n\n                        .details {\n                            height: 100%;\n\n                            .cover {\n                                margin-inline: calc(@space-inline *-1);\n                            }\n\n                            .content-inner {\n\n                                .carousel,\n                                .body,\n                                .report {\n                                    order: unset;\n                                }\n                            }\n                        }\n                    }\n                }\n\n            }\n\n            .viewport {\n                position: relative;\n                width: auto;\n                flex: 1;\n\n                .point-of-interests {\n                    top: 24px;\n                    overflow-x: unset;\n                    padding-block: unset;\n\n                    .ant-space {\n                        flex-wrap: wrap !important;\n                    }\n                }\n\n                .poi-nav-button {\n                    display: none !important;\n                }\n\n                .map-control {\n                    width: 100%;\n                    padding: 24px;\n\n                    .ant-float-btn {\n                        width: 58px;\n                        height: 58px;\n                    }\n\n                    .ant-float-btn-group {\n                        .ant-float-btn-group-wrap {\n                            bottom: 76px;\n                            max-height: 364px;\n\n                            .ant-float-btn {\n                                flex: 0 0 58px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .location-seach {\n            .ant-input-affix-wrapper {\n                border-radius: .5em;\n            }\n        }\n\n        .floor-selector {\n            bottom: 24px;\n            left: 24px;\n\n            .ant-float-btn .ant-float-btn-body,\n            .ant-float-btn.ant-float-btn-group-trigger .ant-float-btn-body {\n                width: 48px;\n                height: 48px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
